// SupportDetails.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { firestore, storage } from '../firebase';
import { Back, Send, Paperclip2, ArrowDown } from 'iconsax-react';
import {ref, uploadBytes, getDownloadURL} from "firebase/storage"

const SupportDetails = () => {
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState(null);
  const navigate = useNavigate()
  const fileInputRef = useRef(null);
  const [newMessage, setNewMessage] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleFileUpload = async () => {
    try {
      setLoading(true);
      if (!selectedFile) {
        return;
      }

      const storageRef = ref(storage, `files/${ticketId}/${selectedFile.name}`);
      await uploadBytes(storageRef, selectedFile);

      const downloadURL = await getDownloadURL(storageRef);

      const messageData = {
        timeStamp: Date.now(),
        message: downloadURL,
        messageType: 'file',
        fileName: selectedFile.name,
        sender: 'user',
      };

      const ticketRef = doc(firestore, 'tickets', ticketId);
      await updateDoc(ticketRef, { messages: [...(ticket.messages || []), messageData] });

      setTicket((prevTicket) => ({
        ...prevTicket,
        messages: [...(prevTicket.messages || []), messageData],
      }));

      setSelectedFile(null);
    } catch (error) {
      console.error('Error uploading file:', error.message);
    } finally{
      setLoading(false)
    }
  };

  const handleSendMessage = async () => {
    if (!newMessage) {
      return;
    }
    try {

      // Define the message data
      const messageData = {
        timeStamp: Date.now(),
        message: newMessage,
        messageType: 'text',
        sender: "user"
      };

      // Add the new message to the 'messages' collection
      

      const ticketRef = doc(firestore, 'tickets', ticketId);
      await updateDoc(ticketRef, { messages: [...(ticket.messages || []), messageData] });

      // Update local state with the new message
      setTicket((prevTicket) => ({
        ...prevTicket,
        messages: [...(prevTicket.messages || []), messageData],
      }));

      // Clear the input field
      setNewMessage('');
    } catch (error) {
      console.error('Error sending message:', error.message);
    }
  };

  useEffect(() => {
    const fetchTicketDetails = async () => {
      try {
        const ticketDoc = await getDoc(doc(firestore, 'tickets', ticketId));
        if (ticketDoc.exists()) {
          setTicket({ id: ticketDoc.id, ...ticketDoc.data() });
        } else {
          console.error('Ticket not found');
        }
      } catch (error) {
        console.error('Error fetching ticket details:', error.message);
      }
    };

    setInterval(() => {
      fetchTicketDetails();
    }, 2000);

  }, [ticketId]);


  useEffect(() => {
  }, [ticket])

  if (!ticket) {
    return <div className='h-screen w-screen flex flex-row items-center justify-center'>Loading...</div>;
  }

  return (
    <div className="p-4 flex h-screen flex-col font-nunito">
      <div className="flex p-5 py-3 items-center bg-white rounded-lg justify-center mb-5">
        <Back size="26" color="#333" className='mr-5' onClick={() => navigate('/support')} variant="TwoTone"/>
        <p className='text-lg mr-auto'>{ticket.surgeryName ? ticket.surgeryName : "General" }</p>
        <input type="file" onChange={handleFileChange} className="hidden" ref={fileInputRef} />
        <div className='bg-gray-100 rounded-lg p-4'>
          <Paperclip2 size="18" color="#333" onClick={() => fileInputRef.current.click()} variant="TwoTone"/>
        </div>
      </div>

      {/* Chat Interface */}
      <div className="border p-4 bg-white mb-5 flex overflow-y-auto flex-col h-full gap-[10px] rounded-md">
        {ticket?.messages?.map((msg) =>(
          <>
            {msg.messageType === "text" && 
              <div className={`text-${msg.sender === 'user' ? 'right' : 'left'} max-w-[75%] m${msg.sender === "user" ? 'l' : 'r'}-auto`}>
                <p className={`bg-${msg.sender === 'user' ? 'gray' : 'gray'}-100 text-wrap text-left text-sm p-3 px-5 rounded-lg`}>{msg.message}</p>
              </div>
            }

            {msg.messageType === "file" && 
              <div onClick={() => {
                window.open(msg.message, '_blank').focus()
              }} className={`text-${msg.sender === 'user' ? 'right' : 'left'} p-3 rounded-lg bg-${msg.sender === 'user' ? 'gray' : 'gray'}-100 flex flex-row items-center max-w-[75%] m${msg.sender === "user" ? 'l' : 'r'}-auto`}>
                <p className={`bg-white text-wrap text-left p-3 px-5 border-dashed	border-2 border-gray-300 text-sm rounded-lg`}>{msg.fileName.length > 12 ? msg.fileName.substring(0,12) + "..." : msg.fileName}</p>
                <ArrowDown size="22" color="#333" className='ml-5' variant="TwoTone"/>
              </div>
            }
          </>
        ))}

      {(!ticket.messages) && <div className='userMsg text-black mt-auto mb-auto text-center w-[100%]'>No Messages yet !!</div>}
  
      </div>

      {/* Message Input */}
      {!selectedFile && <div className="mt-auto flex items-center">
        <input
          onChange={(e) => setNewMessage(e.target.value)}
          value={newMessage}
          className="flex-1 p-2 px-5 h-[56px] border rounded-md"
          placeholder="Type your message..."
        />
        <button onClick={() => handleSendMessage()} className="bg-blue-500 text-white h-[52px] px-4 ml-2 rounded">
          <Send
            size="22"
            color="#fff"
            variant="TwoTone"
          />
        </button>
      </div>} 

      {
        selectedFile && <div className="mt-auto gap-[20px] flex items-center">
          <button disabled={loading} onClick={() => {!loading ? handleFileUpload() : alert("Please Wait")}} className={'w-full bg-blue-500 text-white rounded-lg h-[46px]' + (loading ? " opacity-[0.5] cursor-not-allowed" : "")}>
            {loading ? 'Sending...' : `Send - ${selectedFile.name.length > 8 ? selectedFile.name.substring(0, 6) + "..." : selectedFile.name}`}
          </button>
          <button className='w-full bg-white text-black rounded-lg h-[46px]'>Clear</button>
        </div>
      }
    </div>
  );
};

export default SupportDetails;
